const initialState =
{
    loading: false,
    error: false,
    message: "",
    code: null,
    puestos: [],
    puesto: "1",
    unidadNegocio: null,
    marca: null,
    marcas: [],
    fecha: null,
    indicadores: [],
    calificaciones: {},
    aux: [],
    columnas: [],
    fechaCierre: null,
    cantidadAPV: 0,
    ventasAPV: null,
    CambiosGuardados: true,
}

export default (state = initialState, action) => {
    switch (action.type) {

        case "RESET_DATA_EO":
            return initialState;
        case "LOADING_EO":
            return { ...state, ...action.payload, loading: true, code: null, message: '' }
        case "SAVE_DATA_EO":
            return { ...state, ...action.payload, loading: true, code: null, message: '' }
        case "CHANGE_FILTER_EO":
            return { ...state, ...action.payload }
        case "ERROR_DATA_EO":
            return { ...state, ...action.type, error: true, loading: false }
        case "SUCCESS_DATA_EO":
            return { ...state, loading: false, error: false, indicadores: action.payload.indicadores, calificaciones: action.payload.calificaciones, fechaCierre: action.payload.fechaCierre, fechaValida: action.payload.fechaValida, ventasAPV: action.payload.ventasAPV }
        case "SUCCESS_DATA_EO_AUX":
            return { ...state, loading: false, error: false, aux: action.payload.aux, calificaciones: action.payload.calificaciones }
        case "RESET_DATA_INDICADOR":
            return { ...state, ...action.payload, loading: true }
        case "CHANGE_DATA_INDICADOR":
            return { ...state, ...action.payload, loading: false }
        case "SUCCESS_PUESTOS_EO":
            return { ...state, ...action.payload }
        case "SUCCESS_MARCAS_EO":
            return { ...state, ...action.payload }
        case "SUCCESS_COLUMNAS_EO":
            return { ...state, ...action.payload }
        case "SAVED_EO":
            return { ...state, ...action.payload, loading: false, CambiosGuardados: true }
        case "ERROR_SAVED_EO":
            return { ...state, ...action.payload, loading: false }
        case "GET_APV":
            return { ...state, ...action.payload, loading: true }
        case "SUCCES_GET_APV":
            return { ...state, loading: false, error: false, cantidadAPV: action.payload.cantidad }
        case "GET_APVS":
            return { ...state, ...action.payload, loading: true };

        default:

    }
    return state;
}